<template>
  <div v-if="animatedNumbers" class="grid gap-5 grid-cols-2 md:grid-cols-4">
    <div
      class="overflow-hidden  rounded-lg px-2 py-5 shadow sm:p-6 flex flex-row bg-[#F2EFFF]"
    >
      <img
        src="../../../assets/stats/devicePC.png"
        width="60"
        height="40"
        alt="IconPC"
        class=" w-[60px] h-[60px] items-center object-center my-auto flex"
      />
      <div class="pl-5">
        <dt class="truncate text-sm font-medium text-gray-500">PC</dt>
        <el-tooltip
          effect="dark"
          :content="animatedNumbers[0] + ' vistas'"
          placement="bottom-start"
        >
          <dd
            class="mt-1 text-3xl font-semibold tracking-tight text-gray-900 line-clamp-1"
          >
            <span
              class="font-semibold truncate whitespace-nowrap overflow-hidden text-ellipsis block max-w-[120px] tracking-tight text-gray-900"
              v-if="animatedNumbers[0] !== null"
              >{{ animatedNumbers[0] }}</span
            >
            <span v-else class="loader"></span>
            <span
              class="text-xs ml-1 truncate whitespace-nowrap overflow-hidden text-ellipsis block max-w-[120px]"
            >
              Vistas
            </span>
          </dd>
        </el-tooltip>
      </div>
    </div>
    <div
      class="overflow-hidden rounded-lg px-4 py-5 shadow sm:p-6 flex flex-row bg-[#F2EFFF]"
    >
      <img
        src="../../../assets/stats/deviceMobile.png"
        width="60"
        height="60"
        alt="IconTablet"
        class=" w-[60px] h-[60px] items-center object-center my-auto flex"
      />
      <div class="pl-5">
        <dt class="truncate text-sm font-medium text-gray-500">Mobile</dt>
        <el-tooltip
          effect="dark"
          :content="animatedNumbers[1] + ' vistas'"
          placement="bottom-start"
        >
          <dd
            class="mt-1 text-3xl font-semibold tracking-tight text-gray-900 line-clamp-1"
          >
            <span
              class="font-semibold truncate whitespace-nowrap overflow-hidden text-ellipsis block max-w-[120px] tracking-tight text-gray-900"
              v-if="animatedNumbers[1] !== null"
              >{{ animatedNumbers[1] }}</span
            >
            <span v-else class="loader"></span>
            <span
              class="text-xs ml-1 truncate whitespace-nowrap overflow-hidden text-ellipsis block max-w-[120px]"
            >
              Vistas
            </span>
          </dd>
        </el-tooltip>
      </div>
    </div>
    <div
      class="overflow-hidden rounded-lg px-4 py-5 shadow sm:p-6 flex flex-row bg-[#F2EFFF]"
    >
      <img
        loading="lazy"
        src="../../../assets/stats/deviceTable.png"
        width="60"
        height="60"
        alt="IconMobile"
        class=" w-[60px] h-[60px] items-center object-center my-auto flex"
      />
      <div class="pl-5">
        <dt class="truncate text-sm font-medium text-gray-500">Tablet</dt>
        <el-tooltip
          effect="dark"
          :content="animatedNumbers[2] + ' ' + 'vistas'"
          placement="bottom-start"
        >
          <dd
            class="mt-1 text-3xl font-semibold tracking-tight text-gray-900 line-clamp-1"
          >
            <span
              class="font-semibold truncate whitespace-nowrap overflow-hidden text-ellipsis block max-w-[120px] tracking-tight text-gray-900"
              v-if="animatedNumbers[2] !== null"
              >{{ animatedNumbers[2] }}</span
            >
            <span v-else class="loader"></span>
            <span
              class="text-xs ml-1 truncate whitespace-nowrap overflow-hidden text-ellipsis block max-w-[120px]"
            >
              Vistas
            </span>
          </dd>
        </el-tooltip>
      </div>
    </div>
    <div
      class="overflow-hidden rounded-lg px-4 py-5 shadow sm:p-6 flex flex-row bg-[#F2EFFF]"
    >
      <img
        loading="lazy"
        src="https://cdn-icons-png.flaticon.com/512/9594/9594655.png"
        width="60"
        height="60"
        alt="IconMobile"
        class=" w-[60px] h-[60px] items-center object-center my-auto flex"
      />
      <div class="pl-5">
        <dt class="truncate text-sm font-medium text-gray-500">Otro</dt>
        <el-tooltip
          effect="dark"
          :content="animatedNumbers[3] + ' ' + 'vistas'"
          placement="bottom-start"
        >
          <dd
            class="mt-1 text-3xl font-semibold tracking-tight text-gray-900 line-clamp-1"
          >
            <span
              class="font-semibold truncate whitespace-nowrap overflow-hidden text-ellipsis block max-w-[120px] tracking-tight text-gray-9000"
              v-if="animatedNumbers[3] !== null"
              >{{ animatedNumbers[3] }}</span
            >
            <span v-else class="loader"></span>
            <span
              class="text-xs ml-1 truncate whitespace-nowrap overflow-hidden text-ellipsis block max-w-[120px]"
            >
              Vistas
            </span>
          </dd>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "StatsStore",
  data() {
    return {
      eventsCount: {},
      deviceCount: {},
      numbers: [100, 200, 300, 400],
      animatedNumbers: [null, null, null, null], // Inicialmente null para mostrar el loader
    };
  },
  computed: {
    ...mapState(["storeData", "darkMode"]),
  },
  mounted() {
    this.getEventsCount();
    this.getDeviceCount();
  },
  methods: {
    async getEventsCount() {
      const { success, data } = await this.$store.dispatch(
        "analyticsStore/GET_EVENTS_COUNT"
      );
      if (success && data.success) {
        this.eventsCount = data.data;
      }
    },
    async getDeviceCount() {
      const { success, data } = await this.$store.dispatch(
        "analyticsStore/GET_DEVICE_COUNT"
      );
      if (success && data.success) {
        this.deviceCount = data.data;
        this.numbers = Object.values(this.deviceCount);
        this.startCountAnimation();
      }
    },
    startCountAnimation() {
      this.animatedNumbers = [0, 0, 0, 0];
      this.numbers.forEach((value, index) => {
        this.animateNumber(index, value);
      });
    },
    animateNumber(index, finalValue) {
      const duration = 1000;
      const interval = 10;
      const steps = duration / interval;
      const stepValue = finalValue / steps;

      let currentStep = 0;
      const intervalId = setInterval(() => {
        if (currentStep < steps) {
          this.$set(
            this.animatedNumbers,
            index,
            Math.round(stepValue * currentStep)
          );
          currentStep++;
        } else {
          this.$set(this.animatedNumbers, index, finalValue);
          clearInterval(intervalId);
        }
      }, interval);
    },
  },
};
</script>
<style scoped>
.wrapper-box-shadow {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.09);
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
  display: inline-block;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.truncate-text {
  display: inline-block;
  max-width: 60px; /* Ajusta el ancho según tus necesidades */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
